import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getPostsByLang } from "../data/posts";
import { useLocale } from "../context/LocaleContext";
import "../styles/root.css";

const LATEST_ITEMS_TO_EXCLUDE = 5;

const formatPeriod = (date, lang) => {
  const locale = lang === "mk" ? "mk-MK" : "en-GB";
  return new Date(date).toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

function Projects() {
  const { lang, t } = useLocale();
  const posts = getPostsByLang(lang);

  const projectRows = [...posts]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(LATEST_ITEMS_TO_EXCLUDE);

  return (
    <div>
      <Navbar />
      <div className="home-container">
        <h1 className="headline">{t.projects.headline}</h1>

        <div className="projects-table-wrap">
          <table className="projects-table">
            <thead>
              <tr>
                <th>{t.projects.serialHeader}</th>
                <th>{t.projects.titleHeader}</th>
                <th>{t.projects.periodHeader}</th>
                <th>{t.projects.locationHeader}</th>
                <th>{t.projects.donorHeader}</th>
              </tr>
            </thead>
            <tbody>
              {projectRows.map((post, index) => (
                <tr key={post.slug}>
                  <td>{index + 1}</td>
                  <td>{post.title}</td>
                  <td>{formatPeriod(post.date, lang)}</td>
                  <td>{t.projects.locationValue}</td>
                  <td>&nbsp;</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Projects;
